import {WebConferencesSlidesRepository} from "@api/repositories/WebConferencesSlidesRepository";
import {WebConferencesSlides} from "@api/models/WebСonferencesSlides";
import {Store} from "vuex";

export class SlidesService {
    slides: WebConferencesSlides | null = null;
    isLoaded = false;

    constructor(
        private readonly repository: WebConferencesSlidesRepository,
        private readonly schemaId: string,
        private readonly objectId: string,
        private readonly store: Store<any>
    ) {
    }

    async fetchSlides(id: string) {
        try {
            this.slides = await this.repository.get(this.schemaId, this.objectId, id);
        }
        catch (e) {
            this.store.dispatch('reportError', e);
        }
        finally {
            this.isLoaded = true
        }
    }

    getFileIdByIndex(index: number) {
        return this.slides?.fileIds[index];
    }
}
